/**
 * Development-only console logging.
 *
 * The app carried ~640 bare `console.log` calls, several of them printing API
 * responses and user data straight into the browser console of a production
 * session. Route diagnostics through here instead: it is a no-op once built.
 */
const isDevelopment = process.env.NODE_ENV === "development";

const log = (...args) => {
  if (isDevelopment) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};

export const logError = (...args) => {
  if (isDevelopment) {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};

export default log;
